export default "__VITE_ASSET__CODz1MVr__"